import { getInitModel } from "../services/initModels";
import { MODEL_TYPE } from "../utils/enums";
export function locationServerModel(location) {
  const locationModel = getInitModel(MODEL_TYPE.location, location);
  return {
    Latitude: locationModel.latitude,
    Longitude: locationModel.longitude
  };
}
